/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert text between cases`)
};

const es_cc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte texto entre casos`)
};

const de_cc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konvertiere Text zwischen Schreibweisen`)
};

const nl_cc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet tekst om tussen gevallen`)
};

const fr_cc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir le texte entre différentes casses`)
};

const it_cc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti il testo tra diverse maiuscole`)
};

const pt_br2_cc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter texto entre casos`)
};

const pt_cc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter texto entre casos`)
};

const ja_cc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストをケース間で変換`)
};

const zh_cc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在不同大小写之间转换文本`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_nav_main_desc", locale)
	if (locale === "en") return en_cc_nav_main_desc(inputs)
	if (locale === "es") return es_cc_nav_main_desc(inputs)
	if (locale === "de") return de_cc_nav_main_desc(inputs)
	if (locale === "nl") return nl_cc_nav_main_desc(inputs)
	if (locale === "fr") return fr_cc_nav_main_desc(inputs)
	if (locale === "it") return it_cc_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cc_nav_main_desc(inputs)
	if (locale === "pt") return pt_cc_nav_main_desc(inputs)
	if (locale === "ja") return ja_cc_nav_main_desc(inputs)
	return zh_cc_nav_main_desc(inputs)
};